import type { ZoneGeoJsonPoint, ZoneGeoJsonPolygon } from '@chukua/common';
import { circlePolygon } from './circle-polygon';

/** `[[west, south], [east, north]]`, the shape MapLibre's `bounds` option takes. */
export type LngLatBounds = [[number, number], [number, number]];

interface ZoneArea {
  polygon: ZoneGeoJsonPolygon | null;
  centroid: ZoneGeoJsonPoint | null;
  radiusMeters: number | null;
}

function outline({ polygon, centroid, radiusMeters }: ZoneArea): [number, number][] {
  if (polygon) return polygon.coordinates[0];
  if (!centroid) return [];
  return radiusMeters ? circlePolygon(centroid, radiusMeters).coordinates[0] : [centroid.coordinates];
}

/**
 * The area a saved zone's map opens on: its polygon's outer ring, a point zone's whole circle, or a bare
 * centroid. Null for a zone with no shape, which opens on the corridor overview instead. Most zones are a
 * yard or a gate a few hundred metres across, invisible at the overview's zoom.
 */
export function zoneMapBounds(zone: ZoneArea): LngLatBounds | null {
  const positions = outline(zone);
  if (positions.length === 0) return null;

  const lngs = positions.map(([lng]) => lng);
  const lats = positions.map(([, lat]) => lat);
  return [
    [Math.min(...lngs), Math.min(...lats)],
    [Math.max(...lngs), Math.max(...lats)],
  ];
}
